import type { ReactNode } from 'react'
import type { Spotlight } from '../../hooks/useSpotlight'
import { useTranslation } from '../../hooks/useTranslation'
import type { Cart } from '../../types/display'
import CartFooter from './CartFooter'
import CartList from './CartList'
import ConnectionMark from './ConnectionMark'
import type { ConnectionStatus } from '../../lib/messageSource'

export default function OrderPanel({
  cart,
  currency,
  spotlight = null,
  status = 'online',
  children,
}: {
  cart: Cart | null
  currency: string
  spotlight?: Spotlight | null
  status?: ConnectionStatus
  children?: ReactNode
}) {
  const { t } = useTranslation()
  const items = cart?.items ?? []
  const count = Array.isArray(items) ? items.reduce((n, item) => n + (item.quantity || 0), 0) : 0

  return (
    <div className="relative flex h-full min-h-0 min-w-0 flex-1 flex-col border-r border-divider bg-canvas portrait:border-r-0 portrait:border-t">
      <div className="flex items-baseline space-x-3 px-cfd-gutter pb-cfd-2 pt-cfd-4">
        <div className="text-cfd-label font-medium uppercase text-text-mid">{t('your-order')}</div>
        {count > 0 && (
          <div className="rounded-full bg-bg px-[0.6em] py-[0.1em] font-volte-semibold text-cfd-label tabular-nums text-text-hi">
            {count}
          </div>
        )}
        <ConnectionMark status={status} />
      </div>

      <CartList items={items} currency={currency} spotlight={spotlight} />
      {/* Nothing rung up yet: no row of zeros, just the empty order. */}
      {(count > 0 || !!cart?.cashAmount) && <CartFooter cart={cart ?? {}} currency={currency} />}
      {children}
    </div>
  )
}
